import classNames from 'classnames';

import { figcaption } from '../figCaption/FigCaption.css';
import { figcaptionWrapper, linkedFigcaptionWrapper } from './Figcaption.css';

export const FigcaptionWrapper = ({ children, linked }: { children: React.ReactNode; linked?: boolean }) => {
  return <div className={classNames(figcaptionWrapper, figcaption, linked && linkedFigcaptionWrapper)}>{children}</div>;
};
